/**
 * @summary Round a number and concatinate a Unit to the end.
 * @param {Number} num - The number to convert
 */
export const convertNumber = (num) => {
  if (typeof num !== 'number') {
    num = Number(num);
  }

  if ((num || num === 0) && !isNaN(num)) {
    var neg = num < 0;
    // Change to positive number to process the value
    if (neg) {
      num *= -1;
    }
    num = getNumber(num);
    if (neg) {
      num = '-' + num;
    }
  } else {
    num = '0';
  }

  return num;
};

function getNumber(num) {
  var count = 0;
  var suffixes = ['', 'k', 'M', 'B', 'T'];
  // Reduce the number and update the count to add unit
  if (num > 9999) {
    while (num >= 1000 && count < suffixes.length - 1) {
      num /= 1000;
      count++;
    }
    num = num.toPrecision(3);
  } else {
    // update the number to avoid decimal points
    if (num >= 1000) {
      num = num.toPrecision(4);
    } else {
      num = Math.round(num);
    }
  }
  // Add the unit to the number
  num = Number(num).toLocaleString() + suffixes[count];
  return num;
}

export function renderFileSize(val) {
  if (!val) {
    return val + ' B';
  }
  var output = (val / 1073741824).toFixed(0);
  if (output > 1) {
    return output + ' GB';
  }
  output = (val / 1048576).toFixed(0);
  if (output > 1) {
    if (output > 1000) {
      return (output / 1000).toFixed(0) + ' GB';
    } else {
      return output + ' MB';
    }
  }
  output = (val / 1024).toFixed(0);
  if (output > 1) {
    if (output > 1000) {
      return (output / 1000).toFixed(0) + ' MB';
    } else {
      return output + ' KB';
    }
  }
  return val + ' B';
}
